import { render, staticRenderFns } from "./ItemDetailPart.vue?vue&type=template&id=7bad936e&scoped=true"
import script from "./ItemDetailPart.vue?vue&type=script&lang=js"
export * from "./ItemDetailPart.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailPart.vue?vue&type=style&index=0&id=7bad936e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad936e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bad936e')) {
      api.createRecord('7bad936e', component.options)
    } else {
      api.reload('7bad936e', component.options)
    }
    module.hot.accept("./ItemDetailPart.vue?vue&type=template&id=7bad936e&scoped=true", function () {
      api.rerender('7bad936e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetailPart.vue"
export default component.exports